// extracted by mini-css-extract-plugin
export var actionPlaceholder = "_8q-3";
export var contentContainer = "_8q-0";
export var editorContainer = "_8q-1";
export var quillInputForm = "_8q-2";
export var zoneDivider = "_8q-4";